<template>
    <div class="sc-message">
        <div v-if="unreadNotice" class="sc-message--unread-notice"></div>
        <div
            class="sc-message--content"
            :class="{
                sent: isSender,
                received: !isSender,
                coach: !isPatient
            }"
        >
            <div class="sc-message--wrapper">
                <div class="sc-message--header">
                    <span v-if="message.system_message" class="sc-message--system-msg">{{ __("Message from Vitadio") }}</span>
                    <div class="sc-message--time"><strong v-if="!message.system_message">{{ messageSender }}</strong> <span v-html="messageDate"></span></div>
                </div>
                <div class="sc-message--body">
                    <template v-if="!isSender">
                        <figure v-if="message.system_message" class="user-avatar user-avatar--xs user-avatar--left">
                            <img alt="Vitadio Logo" src="/imgs/logo_vitadio_mail_small.png"> 
                        </figure>
                        <user-avatar v-else :user-info="message.user" size="xs"></user-avatar>
                    </template>
                    <DropdownControl v-else>
                        <li v-if="canBeEdited">
                            <a href="#" @click="editMessage">
                                <span>{{ __('Edit message') }}</span>
                            </a>
                        </li>
                        <li>
                            <a class="text-red" data-dismiss="modal" data-target="#modal-message-delete" data-toggle="modal" href="#" @click="setMessageToRemove">
                                <span>{{ __('Delete message') }}</span>
                            </a>
                        </li>
                    </DropdownControl>
                    <div class="sc-message--body-inner">
                        <div v-if="message.body" class="sc-message--text">
                            <p v-html="message.body"></p>
                        </div>
                        <button v-if="getImages.length > 1" class="sc-message--download-all" type="button" @click="downloadAllImages(getImages)"><svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.9062 6.25C10.9688 6.1875 11 6.125 11 6C11 5.90625 10.9375 5.8125 10.875 5.71875L10.2812 5.09375C10.1875 5.03125 10.0938 5 10 5C9.875 5 9.8125 5.0625 9.75 5.125L6.8125 8.15625V0.375C6.8125 0.28125 6.75 0.1875 6.6875 0.125C6.625 0.0625 6.53125 0 6.4375 0H5.5625C5.4375 0 5.34375 0.0625 5.28125 0.125C5.21875 0.1875 5.1875 0.28125 5.1875 0.375V8.15625L2.25 5.125C2.1875 5.0625 2.09375 5 2 5C1.875 5 1.78125 5.03125 1.71875 5.09375L1.09375 5.71875C1.03125 5.8125 1 5.90625 1 6C1 6.125 1.03125 6.1875 1.125 6.25L5.71875 10.875C5.78125 10.9688 5.875 11 6 11C6.09375 11 6.1875 10.9688 6.28125 10.875L10.9062 6.25ZM11.625 12.375C11.7188 12.375 11.8125 12.4375 11.875 12.5C11.9375 12.5625 12 12.6562 12 12.75V13.625C12 13.75 11.9375 13.8438 11.875 13.9062C11.8125 13.9688 11.7188 14 11.625 14H0.375C0.25 14 0.15625 13.9688 0.09375 13.9062C0.03125 13.8438 0 13.75 0 13.625V12.75C0 12.6562 0.03125 12.5625 0.09375 12.5C0.15625 12.4375 0.25 12.375 0.375 12.375H11.625Z" fill="#5937B7" /></svg>{{ __("Save all") }} ({{ getImages.length }})</button>
                        <div class="sc-message--files">
                            <div v-for="(file, index) in message.files" :key="index" :class="['sc-message--file', { 'is-image': isImage(file.type)}]">
                                <template v-if="message.success !== true">
                                    <template v-if="isImage(file.type)">
                                        <figure v-if="file.path" class="sc-file--image">
                                            <a :href="file.path" class="sc-file--image-download" download><span>{{ __("Save photo") }}</span><svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.9062 6.25C10.9688 6.1875 11 6.125 11 6C11 5.90625 10.9375 5.8125 10.875 5.71875L10.2812 5.09375C10.1875 5.03125 10.0938 5 10 5C9.875 5 9.8125 5.0625 9.75 5.125L6.8125 8.15625V0.375C6.8125 0.28125 6.75 0.1875 6.6875 0.125C6.625 0.0625 6.53125 0 6.4375 0H5.5625C5.4375 0 5.34375 0.0625 5.28125 0.125C5.21875 0.1875 5.1875 0.28125 5.1875 0.375V8.15625L2.25 5.125C2.1875 5.0625 2.09375 5 2 5C1.875 5 1.78125 5.03125 1.71875 5.09375L1.09375 5.71875C1.03125 5.8125 1 5.90625 1 6C1 6.125 1.03125 6.1875 1.125 6.25L5.71875 10.875C5.78125 10.9688 5.875 11 6 11C6.09375 11 6.1875 10.9688 6.28125 10.875L10.9062 6.25ZM11.625 12.375C11.7188 12.375 11.8125 12.4375 11.875 12.5C11.9375 12.5625 12 12.6562 12 12.75V13.625C12 13.75 11.9375 13.8438 11.875 13.9062C11.8125 13.9688 11.7188 14 11.625 14H0.375C0.25 14 0.15625 13.9688 0.09375 13.9062C0.03125 13.8438 0 13.75 0 13.625V12.75C0 12.6562 0.03125 12.5625 0.09375 12.5C0.15625 12.4375 0.25 12.375 0.375 12.375H11.625Z" fill="#5937B7" /></svg></a>
                                            <a :href="file.path" class="sc-file--image-link" :data-lightbox="'message-'+message.uuid">
                                                <img :src="file.path" alt="">
                                            </a>
                                        </figure>
                                        <figure v-else class="sc-file--image">
                                            <a href="#" class="sc-file--image-link">
                                                <img :id="'file-'+message.uuid+'-'+index" :src="imageDataURL(file, index)" alt="">
                                            </a>
                                        </figure>
                                    </template>
                                    <template v-else>
                                        <div v-if="file.path" class="sc-file--doc">
                                            <a :href="file.path" target="_blank" class="file-preview-frame krajee-default kv-preview-thumb" :title="file.filename" download>
                                                <div class="kv-file-content">
                                                    <div class="kv-preview-data file-preview-other-frame">
                                                        <div class="file-preview-other">
                                                            <span class="file-other-icon" v-html="docIcon(file.type)"></span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="file-thumbnail-footer">
                                                    <div class="file-footer-caption">
                                                        <div class="file-caption-info">{{ file.filename }}</div>
                                                        <div class="file-size-info"><samp>{{ fileSize(file.size) }}</samp></div>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                        <div v-else class="sc-file--doc">
                                            <span target="_blank" class="file-preview-frame krajee-default kv-preview-thumb" :title="file.filename" download>
                                                <div class="kv-file-content">
                                                    <div class="kv-preview-data file-preview-other-frame">
                                                        <div class="file-preview-other">
                                                            <span class="file-other-icon" v-html="docIcon(file.type)"></span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="file-thumbnail-footer">
                                                    <div class="file-footer-caption">
                                                        <div class="file-caption-info">{{ file.name }}</div>
                                                        <div class="file-size-info"><samp>{{ fileSize(file.size) }}</samp></div>
                                                    </div>
                                                </div>
                                            </span>
                                        </div>
                                    </template>
                                </template>
                                <template v-else>
                                    <div class="sc-file--loader">
                                        <div class="loader loader--chat loader--grey-background">
                                            <i class="fa fa-spinner fa-spin fa-1x fa-fw" aria-hidden="true"></i>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                    <a v-if="message.success == false" href="" @click.prevent="$emit('modal', message)">
                        <svg width="22" height="22" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="Group">
                                <circle id="Oval" cx="11.175" cy="11.175" r="10.175" stroke="#FF3E57" stroke-width=".55" />
                                <path id="!" fill-rule="evenodd" clip-rule="evenodd" d="M10.8752 13.419c.1155.11.2558.165.4208.165.165 0 .3052-.055.4207-.165.1155-.11.1843-.2695.2063-.4785l.6105-6.40201.0165-.1815c0-.34101-.1183-.61325-.3548-.81675-.2365-.20351-.5362-.30525-.8992-.30525s-.6628.10174-.8993.30525c-.2365.2035-.3547.47574-.3547.81675l.0165.165.6105 6.41851c.022.209.0907.3685.2062.4785zm-.4537 3.2752c.231.2365.5225.3548.8745.3548.352 0 .6435-.1183.8745-.3548.231-.2365.3465-.5307.3465-.8827 0-.352-.1155-.6463-.3465-.8828-.231-.2365-.5225-.3547-.8745-.3547-.352 0-.6435.1182-.8745.3547-.231.2365-.3465.5308-.3465.8828s.1155.6462.3465.8827z" fill="#FF3E57" />
                            </g>
                        </svg>
                    </a>
                </div>
                <template v-if="isSender">
                    <span v-if="isDelivered" class="sc-message--status success">{{ __("Delivered") }}</span>
                    <span v-else-if="message.success === false" class="sc-message--status">{{ __("Message not delivered!") }}</span>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import UserAvatar from '../../../../components/_User/UserAvatar.vue'
export default {
    components: { UserAvatar },
    props: {
        message: {
            type: Object,
            required: true
        },
        last: {
            type: Boolean,
            required: true
        },
        coachId: {
            type: Number,
            required: false
        },
        unreadNotice: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    watch: {
        async message(message) {
            this.$emit('send', true)
        }
    },
    computed: {
        isSender() {
            if(this.message.system_message) {
                return false
            }

            return this.impersonatorOrUser.id === this.message.from || this.coachId === parseInt(this.message.from)
        },
        isPatient() {
            if(this.message.user && this.message.user.patient_id) {
                return true
            } else if (this.message.user && this.message.user.patient) {
                return true
            } else if (this.message.user && this.message.user.roles && this.message.user.roles[0].name === 'patient') {
                return true
            } else {
                return false
            }
        },
        messageDate() {
            const date = moment(this.message.created_at)

            if (moment().diff(date, 'days') < 7 && moment().diff(date, 'days') > 1) {
                return date.format('dddd') + ' ' + date.format('H:mm')
            }

            if (moment().format('D-MM-YYYY') === date.format('D-MM-YYYY')) {
                return this.__('Today') + ' ' + date.format('H:mm')
            }

            if (moment().subtract(1, 'days').format('D-MM-YYYY') === date.format('D-MM-YYYY')) {
                return this.__('Yesterday') + ' ' + date.format('H:mm')
            }

            return date.format('dd Do MMMM') + ' ' + date.format('H:mm')
        },
        getImages() {
            if (this.message.success !== false && _.isArray(this.message.files)) {
                return this.message.files.filter(f => f.is_image)
            } else {
                return []
            }
        },
        isDelivered() {
            if (this.message.success === undefined && this.last) {
                return true
            } else {
                return false
            }
        },
        messageSender() {
            if(this.isSender && this.user.isCoach) {
                return this.__("I")
            } else {
                if(this.isPatient) {
                    return this.message.user.name
                } else {
                    return this.__("[m] Dietitian") + " (" + this.message.user.fullname + ")"
                }
            }
        },
        canBeEdited() {
            const date = moment(this.message.created_at)

            if(moment().subtract(3, 'days').isBefore(date)) {
                return true
            } else {
                return false
            }
        }
    },
    async mounted() {
        if (this.message.success === false) {
            this.$emit('modal', this.message)
        }

        if (this.isDelivered) {
            $('#modal-message-status').modal('hide')
        }

        this.$emit('send', true)
    },
    methods: {
        docIcon(type) {
            if (type === 'PDF' || type === 'application/pdf') {
                return '<svg width="28px" height="36px" viewBox="0 0 28 36" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>FEBBB219-DE67-469C-8384-D2544C3723C4</title> <g id="Android-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="2020-05_diskuse-priloha" transform="translate(-30.000000, -286.000000)"><g id="file-extension" transform="translate(30.000000, 286.000000)"><path d="M1.77556129,0 L20.1318194,0 L27.9943097,7.83196129 L27.9943097,34.1879484 C27.9943097,35.1525032 27.2122065,35.9337935 26.2484645,35.9337935 L1.77556129,35.9337935 C0.811819355,35.9337935 0.029716129,35.1525032 0.029716129,34.1879484 L0.029716129,1.74584516 C0.029716129,0.781290323 0.811909677,0 1.77556129,0 Z" id="Path" fill="#E2574C" fill-rule="nonzero"></path> <text id="PDF" font-family="Nunito-Black, Nunito" font-size="10" font-weight="700" line-spacing="16" fill="#FFFFFF"><tspan x="3.86" y="21">PDF</tspan></text> <path d="M27.9691097,7.85634839 L21.8838968,7.85634839 C20.9201548,7.85634839 20.1380516,7.07424516 20.1380516,6.11050323 L20.1380516,0.0174322581 L27.9691097,7.85634839 Z" id="Path" fill="#B53629" fill-rule="nonzero"></path></g></g></g></svg>'
            }

            if (type === 'DOC' || type === 'DOCX' || type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
                return '<svg width="28" height="36" viewBox="0 0 28 36" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.77563 0H20.1319L27.9944 7.83196V34.188C27.9944 35.1525 27.2123 35.9338 26.2485 35.9338H1.77563C0.811888 35.9338 0.0297852 35.1525 0.0297852 34.188L0.0297852 1.74585C0.0297852 0.78129 0.811979 0 1.77563 0Z" fill="#3B98E7"/><path d="M4.25465 22C3.98132 22 3.77132 21.9267 3.62465 21.78C3.47798 21.6333 3.40465 21.4233 3.40465 21.15V15.8C3.40465 15.5267 3.47798 15.3167 3.62465 15.17C3.77132 15.0233 3.98132 14.95 4.25465 14.95H6.27465C7.05465 14.95 7.72465 15.0933 8.28465 15.38C8.85132 15.66 9.28465 16.0633 9.58465 16.59C9.88465 17.1167 10.0346 17.7433 10.0346 18.47C10.0346 19.2033 9.88465 19.8367 9.58465 20.37C9.29132 20.8967 8.86132 21.3 8.29465 21.58C7.73465 21.86 7.06132 22 6.27465 22H4.25465ZM6.14465 20.52C6.83132 20.52 7.34465 20.3533 7.68465 20.02C8.03132 19.68 8.20465 19.1633 8.20465 18.47C8.20465 17.7767 8.03132 17.2633 7.68465 16.93C7.34465 16.5967 6.83132 16.43 6.14465 16.43H5.24465V20.52H6.14465ZM14.489 22.09C13.769 22.09 13.1424 21.9433 12.609 21.65C12.0824 21.35 11.6757 20.93 11.389 20.39C11.1024 19.8433 10.959 19.2033 10.959 18.47C10.959 17.7367 11.1024 17.1 11.389 16.56C11.6757 16.0133 12.0824 15.5933 12.609 15.3C13.1424 15.0067 13.769 14.86 14.489 14.86C15.209 14.86 15.8324 15.0067 16.359 15.3C16.8924 15.5933 17.299 16.0133 17.579 16.56C17.8657 17.1 18.009 17.7367 18.009 18.47C18.009 19.2033 17.8657 19.8433 17.579 20.39C17.2924 20.93 16.8824 21.35 16.349 21.65C15.8224 21.9433 15.2024 22.09 14.489 22.09ZM14.489 20.68C15.0224 20.68 15.439 20.4933 15.739 20.12C16.039 19.74 16.189 19.19 16.189 18.47C16.189 17.75 16.0357 17.2033 15.729 16.83C15.429 16.4567 15.0157 16.27 14.489 16.27C13.9557 16.27 13.539 16.4567 13.239 16.83C12.939 17.1967 12.789 17.7433 12.789 18.47C12.789 19.1967 12.939 19.7467 13.239 20.12C13.539 20.4933 13.9557 20.68 14.489 20.68ZM22.438 22.09C21.7313 22.09 21.1113 21.9433 20.578 21.65C20.0513 21.3567 19.6413 20.9367 19.348 20.39C19.0613 19.8433 18.918 19.2033 18.918 18.47C18.918 17.7433 19.0613 17.1067 19.348 16.56C19.6413 16.0133 20.0513 15.5933 20.578 15.3C21.1113 15.0067 21.7313 14.86 22.438 14.86C23.2847 14.86 24.028 15.0833 24.668 15.53C24.7813 15.61 24.8613 15.6967 24.908 15.79C24.9613 15.8833 24.988 16.0033 24.988 16.15C24.988 16.3567 24.928 16.5333 24.808 16.68C24.6947 16.82 24.5547 16.89 24.388 16.89C24.288 16.89 24.198 16.8767 24.118 16.85C24.038 16.8167 23.9447 16.7667 23.838 16.7C23.6047 16.56 23.3847 16.46 23.178 16.4C22.9713 16.34 22.758 16.31 22.538 16.31C21.9447 16.31 21.5013 16.49 21.208 16.85C20.9213 17.2033 20.778 17.7433 20.778 18.47C20.778 19.2033 20.9213 19.75 21.208 20.11C21.5013 20.4633 21.9447 20.64 22.538 20.64C22.738 20.64 22.9313 20.61 23.118 20.55C23.3047 20.4833 23.5447 20.3833 23.838 20.25C23.978 20.1767 24.0813 20.1267 24.148 20.1C24.2147 20.0733 24.2947 20.06 24.388 20.06C24.5547 20.06 24.6947 20.1333 24.808 20.28C24.928 20.42 24.988 20.5933 24.988 20.8C24.988 20.94 24.9613 21.06 24.908 21.16C24.8613 21.2533 24.7813 21.34 24.668 21.42C24.028 21.8667 23.2847 22.09 22.438 22.09Z" fill="white"/><path d="M27.9691 7.85454H21.8839C20.9202 7.85454 20.1381 7.07244 20.1381 6.1087V0.015625L27.9691 7.85454Z" fill="#1E7AC8"/></svg>'
            }
        },
        fileSize(size) {
            if (size > 100000) {
                return Number.parseFloat(size / 1000000).toFixed(1).toString() + ' MB'
            }

            return Math.round(size / 1000) + ' KB'
        },
        isImage(type) {
            if (type === 'image/jpeg' || type === 'image/png' || type === 'IMAGE') {
                return true
            } else {
                return false
            }
        },
        imageDataURL(file, index) {
            const reader = new FileReader()
            const vm = this

            reader.onload = function(e) {
                $('#file-' + vm.message.uuid + '-' + index).attr('src', URL.createObjectURL(file))
            }

            reader.readAsDataURL(file) // convert to base64 string
        },
        downloadAllImages(files) {
            for (let n = 0; n < files.length; n++) {
                const link = document.createElement('a')
                link.href = files[n].path
                link.setAttribute('download', files[n].filename)
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
            }
        },
        editMessage() {
            this.$emit('edit', this.message)
        },
        setMessageToRemove() {
            this.$emit('remove', this.message)
        }
    }
}
</script>